import { render } from "./PopUpMenu.vue?vue&type=template&id=863236d2"
import script from "./PopUpMenu.vue?vue&type=script&lang=js"
export * from "./PopUpMenu.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__